import blankButtonStyle from '../../style/BlankButtonStyle'

var avatars = ["avatar1", "avatar1_1", "avatar1_2", "avatar1_3", "avatar1_4", "avatar1_5", "avatar1_6", "avatar2", "avatar2_1", "avatar2_2", "avatar2_3", "avatar2_4", "avatar2_5", "avatar2_6", "avatar3", "avatar3_1", "avatar3_2", "avatar3_3", "avatar3_4", "avatar3_5", "avatar3_6", "avatar4", "avatar4_1", "avatar4_2", "avatar4_3", "avatar4_4", "avatar4_5", "avatar4_6"];

export function randomAvatar(current) {
    var next = avatars[Math.floor(Math.random() * avatars.length)]
    while (next === current) {
        next = avatars[Math.floor(Math.random() * avatars.length)]
    }
    return next
}

export function AvatarChooser(props) {

    var { avatar, height, style, onAvatarUpdated, ...other } = props;

    function randomize() {
        onAvatarUpdated(randomAvatar(avatar))
    }


    var divStyle = Object.assign({
        display: "flex",
        flexDirection: "row",
    }, style)

    return <div style={divStyle} {...other}>
        <img src={`${process.env.PUBLIC_URL}/assets/avatars/128/${avatar}.gif`} height={height} alt="" className="icon" />
        <button onClick={randomize} style={blankButtonStyle}><i className="fas fa-random"></i></button>
    </div>
}
